import { render, staticRenderFns } from "./OrganisationUnits.vue?vue&type=template&id=3bc4d81d&"
import script from "./OrganisationUnits.vue?vue&type=script&lang=ts&"
export * from "./OrganisationUnits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports